<template>
    <div id="accommodation-consideration">
        <v-card-title>
            <v-icon :color="kingsGold" left>mdi-credit-card</v-icon> Payment Method
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-alert :color="infoColor" icon="mdi-information" outlined text>
                    <div class="title">Payment Information</div>
                    A $1000 deposit is required to confirm your residence application. Payment may be made in one
                    of the following ways:
                    <ol>
                        <li>
                            By mailing a $1000 cheque or money order to the Residence Office (address below).
                            Cheques and money orders must be made payable to King's University College and include on
                            the front of the cheque the name and student number of the student requesting residence.
                            Please send your cheque or money order to:<br><br>
                            <b>
                                Residence Office<br>
                                King's University College<br>
                                266 Epworth Ave.<br>
                                London,ON<br>
                                N6A 2M3
                            </b>
                        </li>
                        <li class="pt-3">
                            Make your payment with telephone or internet banking. Use the following link to
                            access further information: <a
                                href="https://www.kings.uwo.ca/current-students/money-matters/fees-and-responsibilities/payment-methods/"
                                target="_blank">Telephone and Internet Banking</a>. Please note: your residence
                            application cannot be processed and until the $1000 deposit is received.
                        </li>
                    </ol>
                    <div class="pt-3 title">Terms</div>
                    By submitting this form electronically, I agree to the following:
                    <ul>
                        <li>
                            I authorize that to the best of my knowledge the information provided on this form
                            is accurate and complete.
                        </li>
                        <li>
                            I understand that I will be placed in a double room. Students who submit a Single
                            Room / Super Single Room Special Needs Accommodation Request Form (see above) will be notified of their
                            placement status by the end of June.
                        </li>
                    </ul>
                    King's University College wishes to ensure the full and fair implementation of the
                    principles of
                    the Ontario Human Rights Code, which states: "every person has the right to equal treatment
                    with
                    respect to services, goods and facilities, without discrimination because of race, ancestry,
                    place of origin, colour, ethnic origin, citizenship, creed, sex, sexual orientation, age,
                    same-sex partnership status, marital status, family status or disability".
                    <div class="pt-3 title">Please Note</div>
                    Your residence application will be processed when the Residence Office receives the
                    following:
                    <ol class="pb-3">
                        <li>A completed residence application form (this form)</li>
                        <li>A properly signed and completed residence agreement (this form)*</li>
                        <li>A $1000 deposit</li>
                    </ol>
                    You will receive a confirmation e-mail within 10 business days of submitting a completed
                    application package (including deposit). The e-mail will be sent to your <b>UWO e-mail account</b>.<br><br>
                    Your residence accommodation is <b>not</b> secured until you receive confirmation from the
                    Residence Office. Submitting the online form and providing the deposit <b>does not</b>
                    guarantee a
                    place in residence.
                    <div class="pt-3 title">Refund Policy</div>
                            Residence deposits are not an additional fee. The $1000 will be applied towards your residence room fee. There are no refunds.
                            <!-- Refunds of 50% of the deposit ($300) are available until June 30, for September move ins, and November 30 for January move ins. 
                            After these dates the deposit is non-refundable. -->
                </v-alert>
                <v-select v-model="item.paymentMethod"
                    hint="Please review Payment Information above for important details" :items="paymentMethodItems"
                    label="Payment Method" persistent-hint placeholder="Not Available" readonly>
                </v-select>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'application-payment-method',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            paymentMethodItems: [{
                    text: 'Credit Card',
                    value: 'Credit Card'
                },
                {
                    text: 'Online Banking (through your bank)',
                    value: 'Online Banking'
                },
                {
                    text: 'Cheque',
                    value: 'Cheque'
                },
                {
                    text: 'Money Order',
                    value: 'Money Order'
                }
            ],
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        }
    }
}
</script>

<style scoped>
.v-card__subtitle {
    font-weight: bold;
}
</style>